export { CustomLink } from "./customLink.js";
export { documentJsonToMarkdown } from "./documentToMarkdown.js";
export { BaseCodeBlock, getContentExtensions } from "./extensions.js";
export type {
  FrontMatterAttrs,
  FrontMatterFieldAttrs,
  FrontMatterFieldError,
  FrontMatterParseResult,
  FrontMatterScalarType,
  FrontMatterSerialization,
  FrontMatterValidation,
  FrontMatterValueKind,
} from "./frontMatter.js";
export {
  FRONT_MATTER_FIELD_NODE_NAME,
  FRONT_MATTER_NODE_NAME,
  parseFrontMatter,
  parseFrontMatterBoolean,
  parseFrontMatterTags,
  serializeFrontMatter,
  serializeFrontMatterTags,
  validateFrontMatter,
} from "./frontMatter.js";
export { FrontMatter, FrontMatterField, frontMatterPositions } from "./frontMatterNodes.js";
export {
  appendSection,
  createSectionSubdocument,
  InvalidSectionManifestError,
  moveSection,
  orderedSectionIds,
  removeSection,
  SECTION_SUBDOCS_KEY,
  sectionReferences,
  UnknownSectionError,
} from "./sectionedDocument.js";
export { SHARED_STARTERKIT_OPTIONS } from "./starterKitOptions.js";

export const EDITOR_SCHEMA_VERSION = "2026-08-03-frontmatter-v1";
